import React from "react";
import Image from "./Images/SterlingLogo.svg";
import OneBank from "./Images/OneBank.svg";
import LogoWhite from "./Images/LogoWhite.svg";
import Zulu from "./Images/zulu.png";
import Adire from "./Images/adire.png";
import Plateau from "./Images/plateau.png";
import Cane from "./Images/cane.png";
import Everything from "./Images/everything.png";
import Facilitator from "./Images/Facilitator.png";
import Banner from "../components/Banner";

export default function LandingPage() {
  return (
    <div>
      <div>
        <Banner />
      </div>

      <div className="flex w-full justify-center p-6 overflow-hidden py-12">
        <img
          src={Image}
          alt="sterling-logo"
          className="w-24 md:w-40 md:mx-8 mx-4"
        />
        <img
          src={LogoWhite}
          alt="LogoWhite-Logo"
          className="w-24 md:w-40 md:mx-8 mx-4"
        />
        <img
          src={OneBank}
          alt="OneBank-logo"
          className="w-24 md:w-40 md:mx-8 mx-4"
        />
      </div>

      <h1 className="flex justify-center text-black text-4xl font-medium mt-12">
        New Product Listings
      </h1>

      <section className="w-10/12 mx-auto flex flex-wrap justify-between py-24">
        <div
          className="w-full md:w-4/12 bg-cover bg-center flex justify-center items-center rounded-xl cursor-pointer mb-6 md:m-0 h-96 md:h-auto"
          style={{ backgroundImage: `url(${Zulu})` }}
        >
          <p className="w-7/12 bg-white bg-opacity-50 text-3xl font-medium text-center py-4">
            Zulu <br /> Painted Beads
          </p>
        </div>
        <div className="w-full md:w-7/12">
          <div
            className="w-full h-80 bg-cover bg-center rounded-xl flex justify-center items-center cursor-pointer"
            style={{ backgroundImage: `url(${Adire})` }}
          >
            <p className="w-7/12 bg-white bg-opacity-50 text-3xl font-medium text-center py-4">
              Zulu <br /> Painted Beads
            </p>
          </div>

          <div className="flex justify-between pt-8">
            <div className="w-5/12 text-center cursor-pointer">
              <img className="mx-auto" src={Plateau} alt="Plateau-img" />
              <p className="border-t-2 border-black py-3 font-medium text-lg">
                Plateau weave basket
              </p>
            </div>
            <div className="w-5/12 text-center cursor-pointer">
              <img className="mx-auto" src={Cane} alt="Cane-img" />
              <p className="border-t-2 border-black py-3 font-medium text-lg">
                Cane basket
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="">
        <div
          className="w-11/12 md:w-10/12 py-32 mx-auto bg-cover bg-center overflow-hidden rounded-xl text-white text-center flex justify-center items-center"
          style={{ backgroundImage: `url(${Everything})` }}
        >
          <div>
            <p className="text-3xl md:text-5xl font-medium">
              Get Everything African
            </p>
            <p className="bg-black bg-opacity-60 text-xl px-16 py-3 capitalize font-medium mt-8">
            Coming Soon to your favorite app store
            </p>
          </div>
        </div>
      </section>

      <section className="flex flex-wrap items-center">
        <div className="w-full md:w-6/12">
          <img src={Facilitator} alt="Facilitator" />
        </div>

        <div className="w-full md:w-6/12 p-8">
          <p className="text-xl font-light">
            <h2 className="text-3xl font-bold mb-4">What is Odara</h2>
            <p className="text-xl leading loose" style={{lineHeight: '40px'}}>
              Odara is a virtual marketplace where people sell, buy and collect
              authentic African products. We make trading easy. Our shop easy
              pay later solution, provides vendors with upfront full payment
              after each order and empowers buyers to split the cost of orders
              into affordable payment overtime.
            </p>
            <button className="text-primary font-light cursor-pointer relative flex items-center">
              Read more
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5  bottom-2 left-24"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </p>
        </div>
      </section>
    </div>
  );
}
